import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './plugins'
import './filters'
import './directive'
import '@mdi/font/css/materialdesignicons.css'
import '@/sass/fonts.css'
import i18n from './plugins/vue-i18n'
import './registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
